import FactCheckIcon from "@mui/icons-material/FactCheck";
import { AdministrationServicePath, SPECIFIC_REQUIREMENTS } from "utils/constants";
import ListSpecificRequirements from "./List";
import permissions from "app/permissions";
import CreateSpecificRequirements from "./Create";
import EditSpecificRequirements from "./Edit";
import ShowSpecificRequirements from "./Show";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  tenancies: [tenants.MU],
  isMenu: true,
  icon: <FactCheckIcon />,
  name: AdministrationServicePath + SPECIFIC_REQUIREMENTS,
  title: "Изисквания за специалности",
  list: <ListSpecificRequirements />,
  create: <CreateSpecificRequirements />,
  createPermission: permissions.canCreateSpecificRequirementTypes,
  edit: <EditSpecificRequirements />,
  editPermission: permissions.canUpdateSpecificRequirementTypes,
  show: <ShowSpecificRequirements />,
  showPermission: permissions.canPreviewSpecificRequirementTypes,
  permission: permissions.canPreviewSpecificRequirementTypes,
};
